import React from 'react';
import EntityForm from './EntityForm';

function ManageGSMForm({ onChanged, selectedEntry = null, setSelectedEntry }) {
    return (
        <EntityForm
            noun="GSM"
            heading="Add New GSM"
            insertUrl="insert_manage_gsm"
            fields={[
                { name: 'name', label: 'Name', required: true },
                { name: 'gsm_value', label: 'GSM Value', required: true },
                { name: 'gsm_type', label: 'GSM Type', type: 'select', options: ['Roll Code', 'Others'], defaultValue: 'Roll Code' },
            ]}
            selectedEntry={selectedEntry}
            setSelectedEntry={setSelectedEntry}
            onChanged={onChanged}
        />
    );
}

export default ManageGSMForm;
